import PromiseMerger from '../promise-merger';
import { getGlobalConfig } from './utils';
const publicKey = Symbol('PUBLIC_KEY');
export class AttachmentStore {
    constructor() {
        this.batchCallback = (uuids, args) => {
            const { batchFetchCount } = getGlobalConfig('attachment', args && args[0]);
            if (batchFetchCount) {
                return batchFetchCount(uuids, { isPublic: args && args[1] });
            }
            return Promise.resolve({});
        };
        this.merger = new PromiseMerger(this.batchCallback, { maxAge: 60000, max: 100 });
    }
    fetchCountInBatch(uuid, field, isPublic) {
        return this.merger.add(uuid, (privateKey) => isPublic ? publicKey : privateKey, [field, isPublic]);
    }
    /**
     * @deprecated
     */
    get(_uuid) {
        return undefined;
    }
    /**
     * @deprecated
     */
    set(_uuid, _cache) {
    }
    /**
     * @deprecated
     */
    getCount(_uuid) {
        return undefined;
    }
    /**
     * @deprecated
     */
    getAttachments(_uuid) {
        return undefined;
    }
    /**
     * @deprecated
     */
    clearCache(_codes) {
    }
}
export default new AttachmentStore();
